import React from 'react';
import { Card, Bleed, Checkbox, BlockStack, Text, Box } from '@shopify/polaris';
import { cn } from '@/lib/utils';
import { PersonalAvatarViewData, PersonalAvatarStatus } from '@/api/personal-avatars';
import { PersonalAvatarCardContent } from './PersonalAvatarCardContent';
import MediaAssetCardQuickViewActions from '@/components/media-asset/MediaAssetCardQuickViewActions';

interface PersonalAvatarCardProps {
  avatar: PersonalAvatarViewData;
  hideUseAction?: boolean;
  size?: 'medium' | 'large';
  hideMetadata?: boolean;
  selected?: boolean;
  onSelect?: (avatar: PersonalAvatarViewData, selected: boolean) => void;
}

export const PersonalAvatarCard: React.FC<PersonalAvatarCardProps> = ({
  avatar,
  hideUseAction = false,
  size = 'large',
  hideMetadata = false,
  selected = false,
  onSelect,
}) => {
  const handleClick = () => {
    if (onSelect) {
      onSelect(avatar, !selected);
    }
  };

  const showActions = !hideUseAction && [PersonalAvatarStatus.DONE].includes(avatar.status);

  return (
    <Box maxWidth="300px">
      <div onClick={handleClick}>
        <Card>
          <Bleed marginInline="400" marginBlock="400">
            <div
              className={cn(
                'relative flex aspect-[9/16] flex-col justify-between overflow-hidden',
                size === 'large' && 'h-[310px]',
                size === 'medium' && 'h-[270px]'
              )}
            >
              <PersonalAvatarCardContent avatar={avatar} />

              {!!onSelect && (
                <div className="absolute right-1 top-1">
                  <Checkbox checked={selected} label="" />
                </div>
              )}
            </div>

            {!hideMetadata && (
              <Box padding="400">
                <BlockStack gap="200">
                  {avatar.createdAt && (
                    <Text as="p" variant="bodySm" tone="subdued">
                      {avatar.createdAt.slice(0, 10)}
                    </Text>
                  )}

                  {avatar.name && (
                    <Text as="h2" variant="bodyMd" fontWeight="semibold" truncate>
                      {avatar.name}
                    </Text>
                  )}

                  <MediaAssetCardQuickViewActions media={avatar} disabled={!showActions} extractPrimaryAction />
                </BlockStack>
              </Box>
            )}
          </Bleed>
        </Card>
      </div>
    </Box>
  );
};
